import { render, staticRenderFns } from "./Audiovideo.vue?vue&type=template&id=302263c9&scoped=true&"
import script from "./Audiovideo.vue?vue&type=script&lang=js&"
export * from "./Audiovideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "302263c9",
  null
  
)

export default component.exports